import { useState, useEffect } from "react";
import { Form, Col, Row, Button } from "antd";
import useGet from "../../../global/hooks/useGet";
import usePost from "../../../global/hooks/usePost";
import CustomInput from "../../../global/components/inputWidgets/CustomInput";
import CustomSelect from "../../../global/components/inputWidgets/CustomSelect";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import { CloseOutlined } from "@ant-design/icons";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import AccountCreationModal from "../../../global/components/AccountCreationModal";

export const SendInvitationForm = ({
  setIsModalOpen,
  setIsOpenModal,
  isOpenModal,
  setModalType,
  modalType,
  isModalOpen,
}) => {
  const [defaultData, setDefaultData] = useState({
    DealerNo: null,
    OemNo: null,
    CustomerNo: null,
  });
  const loggedInUser = JSON.parse(sessionStorage.getItem("userData"));
  const [accountType, setAccountType] = useState(loggedInUser?.role_value);
  const [form] = Form.useForm();
  const [selectedOemNo, setSelectedOemNo] = useState();
  const [selectedDealerNo, setSelectedDealerNo] = useState();
  // const [isOpenModal, setIsOpenModal] = useState(false);
  // const [modalType, setModalType] = useState("");
  // oems/<>/dealers/
  const dealerOptionsUrl =
    selectedOemNo || defaultData?.OemNo
      ? `${process.env.REACT_APP_API_URL}/api/dealers/oems/${
          defaultData?.OemNo ? defaultData.OemNo : selectedOemNo
        }/dealers/`
      : null;
  const postUrl = `${process.env.REACT_APP_API_URL}/api/accounts/invite/`;
  const optionUrl = `${process.env.REACT_APP_API_URL}/api/accounts/options/`;
  const formDealerNo = Form.useWatch("DealerNo", form);
  const isDealerRole = [7, 8, 9].includes(loggedInUser?.role_value);
  const isOemRole = [4, 5, 6].includes(loggedInUser?.role_value);
  const dealerNo = isDealerRole ? loggedInUser?.dealer_no : formDealerNo;
  const getCustomersUrl =
    dealerNo &&
    `${process.env.REACT_APP_API_URL}/api/dealers/${dealerNo}/customers/`;
  const { data: customerData, refetch: customerDataRefetch } =
    useGet(getCustomersUrl);
  const {
    data: optionsData,
    loading: optionDataLoading,
    error: optionDataError,
    refetch: optionDataRefetch,
  } = useGet(optionUrl);
  const getType = getModifiedResponse(optionsData, "roles");
  const modifiedType = getType.filter((item) => item.label !== "Customer");
  const modifiedDealer = getModifiedResponse(optionsData, "dealers");
  const modifiedOems = getModifiedResponse(optionsData, "oems");
  const modifiedCustomer = getModifiedResponse(optionsData, "customers");
  const {
    data: dealerOp,
    loading: delaerOpLoading,
    error: dealerOpError,
    refetch: delaerOpRefetch,
  } = useGet(dealerOptionsUrl);

  const {
    data: postData,
    loading: postLoading,
    error: postError,
    postData: postAction,
  } = usePost(postUrl);

  useEffect(() => {
    delaerOpRefetch();
  }, [selectedOemNo]);

  useEffect(() => {
    if ([4, 5, 6].includes(loggedInUser?.role_value)) {
      setSelectedOemNo(loggedInUser?.oem_no);
    }
  }, [loggedInUser?.oem_no, loggedInUser?.role_value]);

  const onFinish = (values) => {
    try {
      if (loggedInUser?.role_value === 10 || loggedInUser?.role_value === 11) {
        const modifiedValues = {
          ...values,
          OemNo: loggedInUser.oem_no,
          DealerNo: loggedInUser.dealer_no,
          CustomerNo: loggedInUser.customer_no,
          HostLink: window.location.origin,
        };
        postAction(modifiedValues);
      } else if (
        loggedInUser?.role_value === 7 ||
        loggedInUser?.role_value === 8
      ) {
        const modifiedValues = {
          ...values,
          OemNo: loggedInUser.oem_no,
          DealerNo: loggedInUser.dealer_no,
          HostLink: window.location.origin,
        };
        postAction(modifiedValues);
      } else if (
        loggedInUser?.role_value === 4 ||
        loggedInUser?.role_value === 5
      ) {
        const modifiedValues = {
          ...values,
          OemNo: loggedInUser?.oem_no,
          HostLink: window.location.origin,
        };
        postAction(modifiedValues);
      } else {
        const modifiedValues = {
          ...values,
          HostLink: window.location.origin,
        };
        postAction(modifiedValues);
      }
    } catch (error) {
      openErrorNotification("Something went wrong.");
      console.log(error);
    }
  };

  //toat for create
  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong"
      );
    } else if (!postLoading && !postError && postData) {
      openConfirmNotification("Success");
      setIsModalOpen(false);
    }
  }, [postError, postData, postLoading]);

  const handleCreateNew = (type) => {
    setModalType(type);
    setIsOpenModal(true);
  };

  useEffect(() => {
    optionDataRefetch();
    delaerOpRefetch();
    customerDataRefetch();
    if (defaultData) {
      form.setFieldsValue(defaultData);
    }
  }, [defaultData]);

  // console.log(isModalOpen);

  return (
    <div>
      {/* <AccountCreationModal
        isOpenModal={isOpenModal}
        modalType={modalType}
        setIsOpenModal={setIsOpenModal}
        setDefaultData={setDefaultData}
        defaultData={defaultData}
      /> */}
      {modalType ? (
        <AccountCreationModal
          isOpenModal={isOpenModal}
          modalType={modalType}
          setIsOpenModal={setIsOpenModal}
          setDefaultData={setDefaultData}
          defaultData={defaultData}
          setModalType={setModalType}
        />
      ) : (
        <Form
          validateTrigger={"onChange"}
          form={form}
          onFinish={onFinish}
          scrollToFirstError
          layout={"vertical"}
          autoComplete={"off"}
        >
          <div>
            {
              <div className="bg-white rounded-[4px] overflow-hidden">
                <div className="px-2 pt-1 pb-3">
                  <Row gutter={[16, 8]}>
                    <Col span={24}>
                      <CustomInput
                        label="Email"
                        name="Email"
                        type="email"
                        isEmail={true}
                        required
                      />
                    </Col>
                    <Col span={24}>
                      <CustomSelect
                        label="Account Type"
                        name="AccountType"
                        options={modifiedType}
                        placeholder="Please select"
                        onChange={(value) => {
                          setAccountType(value);
                          form.setFieldsValue({
                            OemNo: "",
                            DealerNo: "",
                          });
                          if (isOemRole) {
                            setSelectedOemNo(loggedInUser?.oem_no);
                          } else {
                            setSelectedOemNo("");
                          }
                          setSelectedDealerNo("");
                          setDefaultData((prev) => ({
                            ...prev,
                            OemNo: null,
                            DealerNo: null,
                            CustomerNo: null,
                          }));
                        }}
                        required
                      />
                    </Col>
                  </Row>
                  <Row gutter={[16, 8]}>
                    {![1, 2, 3].includes(accountType) &&
                      [1, 2].includes(loggedInUser?.role_value) && (
                        <Col span={24}>
                          <CustomSelect
                            label="OEM"
                            name="OemNo"
                            options={modifiedOems}
                            placeholder="Please select"
                            onChange={(value) => {
                              setDefaultData((prev) => ({
                                ...prev,
                                OemNo: value,
                                DealerNo: "",
                                CustomerNo: null,
                              }));
                              setSelectedOemNo(value);
                              form.setFieldsValue({
                                DealerNo: "",
                                CustomerNo: null,
                              });
                              setSelectedDealerNo("");
                            }}
                            required
                            handleCreateNew={handleCreateNew}
                            type={"OEM"}
                          />
                        </Col>
                      )}
                    {[7, 8, 9, 10, 11, 12].includes(accountType) &&
                      [1, 2, 4, 5].includes(loggedInUser?.role_value) && (
                        <Col span={24}>
                          <CustomSelect
                            label="Dealer"
                            name="DealerNo"
                            // disabled={
                            //   defaultData?.OemNo
                            //     ? !defaultData?.OemNo
                            //     : !selectedOemNo
                            // }
                            onChange={(value) => {
                              setDefaultData((prev) => ({
                                ...prev,
                                DealerNo: value,
                                CustomerNo: null,
                              }));
                              setSelectedDealerNo(value);
                              form.setFieldsValue({
                                CustomerNo: null,
                              });
                            }}
                            options={
                              dealerOp?.data?.map((item) => ({
                                label: item.name,
                                value: item.value,
                              })) || []
                            }
                            placeholder="Please select"
                            required
                            handleCreateNew={handleCreateNew}
                            type={"Dealer"}
                          />
                        </Col>
                      )}
                    {[10, 11, 12].includes(accountType) &&
                      [1, 2, 3, 4, 5, 6, 7, 8, 9].includes(
                        loggedInUser?.role_value
                      ) && (
                        <Col span={24}>
                          <CustomSelect
                            // disabled={
                            //   defaultData?.OemNo && defaultData?.DealerNo
                            //     ? !defaultData?.OemNo || !defaultData?.DealerNo
                            //     : !selectedOemNo || !selectedDealerNo
                            // }
                            label="Customer"
                            name="CustomerNo"
                            options={
                              customerData?.data?.map((item) => ({
                                label: item.name,
                                value: item.value,
                              })) || []
                            }
                            placeholder="Please select"
                            required
                            handleCreateNew={handleCreateNew}
                            type={"Customer"}
                          />
                        </Col>
                      )}
                  </Row>
                </div>
                <div className="flex justify-center space-x-2 mt-2.5">
                  <Button
                    type="primary"
                    className="mr-2 min-w-[104px] h-[30px] py-1 px-[10px] font-medium flex items-center "
                    onClick={() => form.submit()}
                    loading={postLoading}
                  >
                    <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
                    <span className="">Apply</span>
                  </Button>
                  <Button
                    className="reset-button"
                    onClick={() => {
                      form.resetFields();
                      setIsModalOpen(false);
                      setDefaultData({
                        DealerNo: null,
                        OemNo: null,
                        CustomerNo: null,
                      });
                    }}
                  >
                    <CloseOutlined />
                    <span className="">Cancel</span>
                  </Button>
                </div>
              </div>
            }
          </div>
        </Form>
      )}
    </div>
  );
};
